// import React from "react";

// export function CardComp({ src, alt, className }) {
//   const isHomeImgPod = className === "homeImgPod";
//   return (
//     <div  style={{ width: isHomeImgPod ? "auto" : "150px" }}>
//       <img
//         src={src}
//         alt={alt}
//         className={className ? className : "homeImgCard"}
//         // className={`homeImgCard ${className || ""}`}
//         width="640"
//         height="360"
//         loading="lazy"
//       />
//     </div>
//   );
// }

// import React from "react";

// export function CardComp({ src, alt, className }) {
//   const isHomeImgPod = className === "homeImgPod";
//   return (
//     <div style={{ width: isHomeImgPod ? "auto" : "160px" }}>
//       <img
//         src={src}
//         alt={alt}
//         className={className ? className : "homeImgCard"}
//         // className={`homeImgCard ${className || ""}`}
//         width="100%"
//         // height="auto"
//         loading="lazy"
//       />
//     </div>
//   );
// }



import React from "react";

export function CardComp({ src, alt, className }) {
    const shouldWrapInDiv = !className || !className.includes("no-wrapper");

    return shouldWrapInDiv ? (
        <div className="cardImgdiv">
            <img
                src={src}
                alt={alt}
                className={className || "homeImgCard"}
                width="100%"
                height="auto"
                loading="lazy"
            />
        </div>
    ) : (
        <img
            src={src}
            alt={alt}
            className={className || "homeImgCard"}
            width="100%"
            height="auto"
            loading="lazy"
        />
    );
}